import { scoreColor } from "../lib/labels";

export default function ScoreGauge({ score, label, size = 200 }) {
  const stroke = 14;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;
  const color = scoreColor(score);

  return (
    <div data-testid="vehicle-score-badge" className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#1E293B" strokeWidth={stroke} />
          <circle
            className="gauge-arc"
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke={color} strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={circ} strokeDashoffset={offset}
            style={{ "--gauge-circ": circ, filter: `drop-shadow(0 0 10px ${color}66)`, transition: "stroke-dashoffset 1.2s ease-out" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading font-extrabold text-5xl" style={{ color }}>{score}</span>
          <span className="text-xs text-slate-400 mt-1">/ 100</span>
        </div>
      </div>
      <span data-testid="vehicle-score-label"
        className="mt-3 px-4 py-1.5 rounded-full text-sm font-semibold border"
        style={{ color, borderColor: `${color}55`, backgroundColor: `${color}14` }}>
        {label}
      </span>
    </div>
  );
}
